module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/existingpatient/existingpatient.component.css
// module id = ./src/app/Pages/tasks/existingpatient/existingpatient.component.css
// module chunks = main